import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../api/axios";
import { CustomerOperations } from "./types";

// Single customer-operations endpoint keyed by backend location id. The view is
// generic; the backend maps each robotics system's operations into one session
// shape (LogiCS today, VLC later).
export const useCustomerOperations = (locationId: number) => {
  return useQuery({
    queryKey: ["customerOperations", locationId],
    queryFn: async () => {
      const response = await api.get<CustomerOperations>(
        `/customeroperations/location/${locationId}`
      );
      return response.data;
    },
    refetchInterval: 15000,
  });
};
